import type { CampaignInfo } from 'app/src/model'
import { membershipApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import { DateTime, Duration } from 'luxon'
import { Skeleton } from 'primereact/skeleton'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function TimerWidget() {
  const context = useWebAppContext()
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.TimerAndBalance' })
  const globalTranslation = useTranslation('home', { keyPrefix: 'Global' })

  const phaseAndDeadline: CampaignInfo = membershipApi.getPhaseAndDeadline(context.userInfo.welfareCampaign)
  const [timeRemaining, setTimeRemaining] = useState<Duration>()
  const timerText = t(phaseAndDeadline.phase)

  useEffect(() => {
    if (phaseAndDeadline.deadline) {
      const interval = setInterval(
        () => {
          const now = DateTime.local()
          const target = DateTime.fromISO(phaseAndDeadline.deadline!)
          const diff = target.diff(now, ['days', 'hours', 'minutes'])
          setTimeRemaining(diff)
        },
        !timeRemaining ? 1000 : 10000,
      )

      return () => clearInterval(interval)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phaseAndDeadline.deadline])

  return (
    phaseAndDeadline.deadline &&
    (timeRemaining ? (
      <div className='grid min-h-[100px] grid-cols-12' data-testid='TimerWidget'>
        <div className='timer-calendar-icon-box col-span-2 flex items-center justify-center bg-[var(--primary-color)]'>
          <i className='pi pi-calendar timer-calendar-icon' style={{ fontSize: '2rem' }}></i>
        </div>

        <div className='timer-countdown col-span-10 grid grid-rows-2 p-2'>
          <div className='timer-phase-text'>{timerText}</div>

          <div className='grid grid-cols-12 pl-2'>
            <div className='col-span-4'>
              <span className='timer-number'>{timeRemaining.days.toFixed(0)}</span>
              <span className='timer-fraction'> {globalTranslation.t('Days')}</span>
            </div>
            <div className='col-span-4'>
              <span className='timer-number'>{timeRemaining.hours.toFixed(0)}</span>
              <span className='timer-fraction'> {globalTranslation.t('Hours')}</span>
            </div>
            <div className='col-span-4'>
              <span className='timer-number'>{timeRemaining.minutes.toFixed(0)}</span>
              <span className='timer-fraction'> {globalTranslation.t('Minutes')}</span>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Skeleton height='5rem' data-testid='loading-element'></Skeleton>
    ))
  )
}
